export const pxToRem = (pixels: string | number) => {
  const baseSize = 15;
  if (typeof pixels === 'string') {
    return `${+pixels.slice(0, -2) / baseSize}rem` || '1rem';
  }
  return pixels / baseSize || 1;
};
